import styled from "styled-components";

export const InformationBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 30px 14px 30px;
`;
